import React, { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

export const ThemeToggle = () => {
    const [dark, setDark] = useState(() => localStorage.getItem("simonara-theme") === "dark");

    useEffect(() => {
        document.documentElement.classList.toggle("dark", dark);
        localStorage.setItem("simonara-theme", dark ? "dark" : "light");
    }, [dark]);

    return (
        <button
            onClick={() => setDark((v) => !v)}
            aria-label="Toggle dark mode"
            data-testid="theme-toggle"
            className="inline-flex items-center justify-center w-9 h-9 rounded-full border border-border text-foreground hover:bg-muted transition-colors"
        >
            {dark ? <Sun size={16} /> : <Moon size={16} />}
        </button>
    );
};

export default ThemeToggle;
